// extracted by mini-css-extract-plugin
export default {"main":"Card_main__KbZ-R","selected":"Card_selected__ZPOat"};